// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JZyNN","tabsBox":"styles_tabsBox__Cxv1b","createButton":"styles_createButton__eDR3D"};